export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/83e791c702f67cc0242109b04d241be7.svg";